import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { VantaAuthService } from '../services/vantaAuthService';
import { environment } from '../../../environments/environment';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
	public constructor(private readonly authService: VantaAuthService) { }

	public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		if (req.headers.has('Authorization')) {
			return next.handle(req);
		}
		if (!environment.USE_CONNECT_PLATFORM) {
			return next.handle(req);
		}
		const authToken = this.authService.getIdTokenValue();
		if (!authToken) {
			return next.handle(req);
		}

		const reqWithAuthToken = req.clone({
			headers: req.headers.set('Authorization', `Bearer ${authToken}`)
		});
		return next.handle(reqWithAuthToken);
	}
}
